import { leadsTabTypes, statusTypes } from './constants';

const hasTruthy = { _eq: true };
const hasFalsy = { _eq: false };

const getStatusFilterCondition = (status) => {
  const includesClosedWon = status?.includes(statusTypes.ClosedWon);
  const includesClosedLost = status?.includes(statusTypes.ClosedLost);

  if (includesClosedWon) {
    return [{ closed_won: hasTruthy }];
  } else if (includesClosedLost) {
    return [{ closed_lost: hasTruthy }];
  } else {
    return [{ closed_won: hasTruthy }, { closed_lost: hasTruthy }];
  }
};

export const getLeadsQueryForTab = (tab, status = []) => {
  const tabQueries = {
    [leadsTabTypes.Active]: {
      _or: status.length
        ? status.map((s) => ({ [s]: hasTruthy }))
        : [
            { closed_won: hasFalsy },
            { closed_lost: hasFalsy },
            { new: hasTruthy },
          ],
    },
    [leadsTabTypes.Archive]: {
      _or: getStatusFilterCondition(status),
    },
    [leadsTabTypes.Appointments]: {
      _or: [{ booked_visit: hasTruthy }],
    },
  };

  return tabQueries[tab] || null;
};
